export const PROMO_CODES_RAW = `
MENDYX25-ZTSAZV95	MENDYX15-ZYWV5AKX					
MENDYX25-ZSW4JUVQ	MENDYX15-ZXZ6J73C					
MENDYX25-ZPKTEQ3W	MENDYX15-ZLTCQG88					
MENDYX25-XC7PXFP2	MENDYX15-ZLCUX7NG					
MENDYX25-WL3PQ5LK	MENDYX15-ZF8BRX7V					
MENDYX25-W83RLAJZ	MENDYX15-ZC6SPKGZ					
MENDYX25-VYVWUYXT	MENDYX15-ZB7ML92K					
MENDYX25-USTDEZ8Q	MENDYX15-ZA8F94PQ					
MENDYX25-UPSVMFB9	MENDYX15-Z9M8PZYN					
MENDYX25-U95MGUWA	MENDYX15-Z8CN4H5J					
MENDYX25-TJ6ZR4MU	MENDYX15-Z67CPVYM					
MENDYX25-T9EYRWQJ	MENDYX15-YYUZEM4B					
MENDYX25-SFSMTBEA	MENDYX15-YYHTNTAR					
MENDYX25-S9N845E9	MENDYX15-YWR5EU98					
MENDYX25-RZLGK539	MENDYX15-YW2Y8BBT					
MENDYX25-RJ3QFS2J	MENDYX15-YVUAKWNY					
MENDYX25-QVNXRJW6	MENDYX15-YUCTVUHZ					
MENDYX25-QFSE7G56	MENDYX15-YU4Y3QRB					
MENDYX25-Q7G8D7TP	MENDYX15-YRAXHCXN					
MENDYX25-PFWM4Y3Z	MENDYX15-YP38M6YQ					
MENDYX25-NG92MNBR	MENDYX15-YH3TD2XF					
MENDYX25-N9F8869T	MENDYX15-YGWLEEF8					
MENDYX25-KK65YR6E	MENDYX15-YFTEZ489					
MENDYX25-KBJJVZXU	MENDYX15-YF7A3Q65					
MENDYX25-HWH69RSG	MENDYX15-YBUT3SXL					
MENDYX25-GWYW8PLD	MENDYX15-YAUQFVNQ					
MENDYX25-GN8G2U5K	MENDYX15-Y9Z4Q944					
MENDYX25-G6LHJZ4P	MENDYX15-Y9KWTXTG					
MENDYX25-EKBGUH8Z	MENDYX15-Y52GNSVC					
MENDYX25-EFFYA967	MENDYX15-Y3HEXNYX					
MENDYX25-E2M3DSK6	MENDYX15-Y2UMNAE8					
MENDYX25-D4NUZJ32	MENDYX15-Y2GJXQUX					
MENDYX25-CL4Q5KEG	MENDYX15-XZBWTVEC					
MENDYX25-CHGSATR4	MENDYX15-XYFPT8KS					
MENDYX25-CBMUD2Y6	MENDYX15-XXPUWHFR					
MENDYX25-C8JDQBRC	MENDYX15-XPPLHGU5					
MENDYX25-BAN7ZVMA	MENDYX15-XLVEV9KT					
MENDYX25-ATGNTJZS	MENDYX15-XHL59MQQ					
MENDYX25-AR6NCED8	MENDYX15-XBGD44CE					
MENDYX25-9J9U8RC4	MENDYX15-XAHVVE7H					
MENDYX25-9DAJEZUC	MENDYX15-X4M9PD39					
MENDYX25-8SAHGVNX	MENDYX15-X2HRMH9F					
MENDYX25-8AU4DPLY	MENDYX15-WZLF55SW					
MENDYX25-8424NXWT	MENDYX15-WYNN4D4C					
MENDYX25-7J83KA22	MENDYX15-WSHTQ3N8					
MENDYX25-6FT8PSCB	MENDYX15-WRUG55UX					
MENDYX25-5R6D4QAR	MENDYX15-WNZKLV9X					
MENDYX25-5P4BSSTP	MENDYX15-WHEZ4ZC8					
MENDYX25-5656UW99	MENDYX15-WFQB9N9X					
MENDYX25-36GAKFJN	MENDYX15-WATU47BL					
MENDYX25-ZUV2DWPZ	MENDYX15-WAP9J7RL					
MENDYX25-ZUTMR74E	MENDYX15-W272PYGU					
MENDYX25-ZTY28SU7	MENDYX15-VWSZ744Y					
MENDYX25-ZS84QVRX	MENDYX15-VUN6RPHE					
MENDYX25-ZQ83VFW7	MENDYX15-VUD95UXX					
MENDYX25-ZM7DE4YG	MENDYX15-VQW2KMA2					
MENDYX25-ZKY6YWLV	MENDYX15-VPXGZ6V2					
MENDYX25-ZKGSWZZ9	MENDYX15-VKJ33HSA					
MENDYX25-ZJ2CL2CJ	MENDYX15-VH2B4E3W					
MENDYX25-ZHUVADNP	MENDYX15-VERGMEAR					
MENDYX25-ZG5YE5AE	MENDYX15-VDXVWQRD					
MENDYX25-ZDV7EKTE	MENDYX15-VCXTXBJ5					
MENDYX25-ZCXRKJMA	MENDYX15-VAYYAWKZ					
MENDYX25-ZB5AZ33G	MENDYX15-VAE6LPPC					
MENDYX25-Z58Q2B5N	MENDYX15-V92JFL5G					
MENDYX25-YWSZD9YV	MENDYX15-V7DQPYX9					
MENDYX25-YTVUSL3P	MENDYX15-V3QZT5TL					
MENDYX25-YRAZLYXB	MENDYX15-UZR5TUZW					
MENDYX25-YMQNBMNS	MENDYX15-UZAC5ZUR					
MENDYX25-YGR69RAT	MENDYX15-UYY47UCF					
MENDYX25-YG7BGHKZ	MENDYX15-UWLZYDHL					
MENDYX25-YBJ3BELH	MENDYX15-UWJ7J5SC					
MENDYX25-YB7RV5AY	MENDYX15-UUCRCFJW					
MENDYX25-Y78QELMT	MENDYX15-UU5UFQ5X					
MENDYX25-Y3JUHX9Z	MENDYX15-UTTK8ENH					
MENDYX25-XYSZF8Z5	MENDYX15-UT3Q82F2					
MENDYX25-XY7J4BME	MENDYX15-UQXU7LXM					
MENDYX25-XXKDCACM	MENDYX15-UPX9ZSUP					
MENDYX25-XV94MQW5	MENDYX15-UPQA5WAF					
MENDYX25-XREPVZ5Z	MENDYX15-UJ2ZMLZY					
MENDYX25-XR67YP3R	MENDYX15-UGYSBBTR					
MENDYX25-XP876SJE	MENDYX15-UFZPZ9YQ					
MENDYX25-XNC89WUU	MENDYX15-UDXYQZSR					
MENDYX25-XMUAVMX2	MENDYX15-UDPET5JT					
MENDYX25-XML26YRB	MENDYX15-U7PMRP8G					
MENDYX25-XGE432XQ	MENDYX15-U5XJNV85					
MENDYX25-XG9XHMNK	MENDYX15-U4WA3U9H					
MENDYX25-XDZSLXTL	MENDYX15-TYTMP33R					
MENDYX25-XDY43B9W	MENDYX15-TYL2WAZ8					
MENDYX25-XCS5MUE2	MENDYX15-TWSAX9Z5					
MENDYX25-XBEUW4RJ	MENDYX15-TT5RTR9K					
MENDYX25-X78WEQKQ	MENDYX15-TSJ5BKFK					
MENDYX25-X72CJAZQ	MENDYX15-TQ3TURLZ					
MENDYX25-X6Z7J4NM	MENDYX15-TPU4CBGY					
MENDYX25-X6R6LGBA	MENDYX15-TNGW55Q7					
MENDYX25-X5Z4VA8G	MENDYX15-TJZQF6UB					
MENDYX25-X3AJC6PJ	MENDYX15-THL9VMGY					
MENDYX25-WX5EYZRQ	MENDYX15-THJST6ML					
MENDYX25-WWNA3TJM	MENDYX15-TGLY5SDU					
MENDYX25-WV94877D	MENDYX15-TFTSYPGW					
MENDYX25-WUS9VVFD	MENDYX15-TE5PFK9P					
MENDYX25-WTR438QQ	MENDYX15-T2AKZCNL					
MENDYX25-WSWEZEWB	MENDYX15-SYS7KQDL					
MENDYX25-WR3Q7X4K	MENDYX15-SYFXNHS6					
MENDYX25-WNGC3EU3	MENDYX15-SY2C9Z26					
MENDYX25-WHXPM6FL	MENDYX15-SX4G43ED					
MENDYX25-WHU9JELM	MENDYX15-SVT6B8BA					
MENDYX25-WFADPEZJ	MENDYX15-SVM6RC3U					
MENDYX25-W8SWJYCH	MENDYX15-SSMSCQDY					
MENDYX25-W6V5UJUQ	MENDYX15-SHVTBE8A					
MENDYX25-W6EJ6D5U	MENDYX15-SEWFZ8PS					
MENDYX25-W5ZK5BVP	MENDYX15-SEDESJ4E					
MENDYX25-W4W7QE3K	MENDYX15-SDU9JDDU					
MENDYX25-VUR9WCAD	MENDYX15-S8UU9EUK					
MENDYX25-VTJP4EZL	MENDYX15-S6PBT5EL					
MENDYX25-VPXYLVGN	MENDYX15-S37SGPE4					
MENDYX25-VKXRDVQQ	MENDYX15-RZ8D5HBM					
MENDYX25-VJSTTM2D	MENDYX15-RZ76ZK2P					
MENDYX25-VJ669459	MENDYX15-RYZMRF48					
MENDYX25-VH9X857V	MENDYX15-RY2LZ6MG					
MENDYX25-VCX9E86Y	MENDYX15-RR4R6A3N					
MENDYX25-V5U6GJNH	MENDYX15-RN6D6MLN					
MENDYX25-V3JV9ZRA	MENDYX15-RH4T4B55					
MENDYX25-UZ6WD4XR	MENDYX15-RE6FUH6Y					
MENDYX25-UTAT4YEA	MENDYX15-RDZ4EUW4					
MENDYX25-UT5MV4H3	MENDYX15-RCEGGF4S					
MENDYX25-UT23LRRG	MENDYX15-RBDYWRNP					
MENDYX25-US3AE4WW	MENDYX15-R5M7XS3Y					
MENDYX25-UQPSBMY9	MENDYX15-QZXAXEE7					
MENDYX25-UK5DQAYK	MENDYX15-QYTSRM3Q					
MENDYX25-UHGD5NGR	MENDYX15-QW5CA7T4					
MENDYX25-TYZ7XV7P	MENDYX15-QPVVBAWD					
MENDYX25-TY7D8AJJ	MENDYX15-QKLW5WMK					
MENDYX25-TUHDVHHD	MENDYX15-QJ2A7RRU					
MENDYX25-TUDSS6NK	MENDYX15-QHLEAZ85					
MENDYX25-TK2KN7X5	MENDYX15-QFW2XM6P					
MENDYX25-TJPA5JXN	MENDYX15-QC9ZP8YH					
MENDYX25-TJAF4NUN	MENDYX15-Q9J6RL8Q					
MENDYX25-TJ23XMWT	MENDYX15-Q9BWB3B2					
MENDYX25-TGK9KZV6	MENDYX15-Q963Z22E					
MENDYX25-TA2HGUWB	MENDYX15-Q85VDTAT					
MENDYX25-T9RHBKP6	MENDYX15-Q6GU4LSQ					
MENDYX25-T984FZH5	MENDYX15-Q5LX6KNN					
MENDYX25-T4799AEC	MENDYX15-PXSYMTCB					
MENDYX25-T3BXUU57	MENDYX15-PXNKVCPK					
MENDYX25-T392T62U	MENDYX15-PSG2ZLW3					
MENDYX25-SQCR32NW	MENDYX15-PS65FPK2					
MENDYX25-SQ8WJCDH	MENDYX15-PN5X8KHP					
MENDYX25-SJV6H7CV	MENDYX15-PFVDTN3Q					
MENDYX25-SEGH2BTL	MENDYX15-PFGPFBRJ					
MENDYX25-SDMYG74Q	MENDYX15-PDJ6VK8C					
MENDYX25-SD454UFH	MENDYX15-PBHQBMTQ					
MENDYX25-SD3SY69A	MENDYX15-PB2YTAFK					
MENDYX25-S2VRMUTF	MENDYX15-NZAHLG8L					
MENDYX25-RWYC8QEQ	MENDYX15-NWXXNCSZ					
MENDYX25-RWWLS9TX	MENDYX15-NW3P9F4M					
MENDYX25-RWPVQP47	MENDYX15-NUJTPD3T					
MENDYX25-RU9VPV5B	MENDYX15-NSUF44RN					
MENDYX25-RPZHVHWF	MENDYX15-NSG696PP					
MENDYX25-RJYCKCBN	MENDYX15-NGWRFEQ3					
MENDYX25-RGNYMV38	MENDYX15-NGGMU93X					
MENDYX25-RDP4FTCT	MENDYX15-NB7SELJC					
MENDYX25-RDF3MNBB	MENDYX15-N4XXFBTZ					
MENDYX25-RBW8UADV	MENDYX15-N2PUC85D					
MENDYX25-QY3DM5UW	MENDYX15-MY4CRJ7T					
MENDYX25-QTUXM5NL	MENDYX15-MWVNZYUD					
MENDYX25-QSHAHHLM	MENDYX15-MTFS4JDH					
MENDYX25-QSBDJCPX	MENDYX15-MS93B6Y8					
MENDYX25-QRTMKX8Y	MENDYX15-MJ8M39ZB					
MENDYX25-QN35ZAYW	MENDYX15-MFCSFZKL					
MENDYX25-QG7JD7C6	MENDYX15-MF4XNGB4					
MENDYX25-QEUFQ37E	MENDYX15-ME8ZKU6F					
MENDYX25-QBTGVZYE	MENDYX15-MBYKUM67					
MENDYX25-Q97GHZ9X	MENDYX15-MBJNUCSF					
MENDYX25-Q7R66235	MENDYX15-M57FRRSB					
MENDYX25-Q5H9BJL8	MENDYX15-M4V326ND					
MENDYX25-Q5FFTFA5	MENDYX15-LZWPYX6H					
MENDYX25-Q4ZMKG3T	MENDYX15-LWU48QSB					
MENDYX25-PWVALV7K	MENDYX15-LWGSZJK8					
MENDYX25-PWMNW3RE	MENDYX15-LU5SMWX2					
MENDYX25-PWFRFFKL	MENDYX15-LQKQTST3					
MENDYX25-PTUGB7V5	MENDYX15-LNPGCXRD					
MENDYX25-PSTSRPUW	MENDYX15-LN36R8XF					
MENDYX25-PSNEJNWR	MENDYX15-LJXT29BD					
MENDYX25-PSLCRTC6	MENDYX15-LJH4DTPZ					
MENDYX25-PMZ9N56A	MENDYX15-LA7K7Y8V					
MENDYX25-PMSHTLYA	MENDYX15-L3QEJAQS					
MENDYX25-PMGADXUC	MENDYX15-KYC55NZQ					
MENDYX25-PLUKAZJK	MENDYX15-KXULYA4A					
MENDYX25-PKRFE265	MENDYX15-KUBB6QWZ					
MENDYX25-PJ58A352	MENDYX15-KSXTL8G8					
MENDYX25-PGN5F6NP	MENDYX15-KSXPL9RM					
MENDYX25-PF5KDHAQ	MENDYX15-KRB9DQT7					
MENDYX25-PA85KAQ2	MENDYX15-KKM37RKB					
MENDYX25-P6TMD7J7	MENDYX15-KKFRS2C2					
MENDYX25-NYE77355	MENDYX15-KJJJ58ND					
MENDYX25-NXLJ7RFY	MENDYX15-KBZKS6ED					
MENDYX25-NVPRZF8N	MENDYX15-KBEQ9C8Y					
MENDYX25-NVFY2UUL	MENDYX15-K8EZ4Q7B					
MENDYX25-NVFNRGLX	MENDYX15-K7MUHC8P					
MENDYX25-NULLV4LV	MENDYX15-K75GNUYK					
MENDYX25-NUHTDQ9V	MENDYX15-K3JQDXXX					
MENDYX25-NTGV7H8F	MENDYX15-K3B2ADN8					
MENDYX25-NJB6Z4YA	MENDYX15-JTCJK6YV					
MENDYX25-NHX6W5DC	MENDYX15-JT8F3P89					
MENDYX25-NHKASE6T	MENDYX15-JPW45762					
MENDYX25-NCAXNZHY	MENDYX15-JNC5S55S					
MENDYX25-NB3Q9VFQ	MENDYX15-JMWVLPV6					
MENDYX25-NARGMFSF	MENDYX15-JL9ZUW77					
MENDYX25-N7VHNWGS	MENDYX15-JKLZDEV9					
MENDYX25-N5Z9PY66	MENDYX15-JGXW73G4					
MENDYX25-N5WWTLME	MENDYX15-JG8MWUCM					
MENDYX25-N4UH264N	MENDYX15-JENQQG6W					
MENDYX25-N2FTY3G2	MENDYX15-JCEFPZEV					
MENDYX25-MY5Q9Z4Y	MENDYX15-JB7J2DH5					
MENDYX25-MXNEEFJL	MENDYX15-J5Q8RC68					
MENDYX25-MUHQPSZU	MENDYX15-J35JV92B					
MENDYX25-MU3HZUVN	MENDYX15-HZLSN29H					
MENDYX25-MQJMKVWE	MENDYX15-HYT88C7D					
MENDYX25-MPX32HZV	MENDYX15-HWL5K6YH					
MENDYX25-MPFM5K5H	MENDYX15-HVX73ZJ5					
MENDYX25-MP7JWAPS	MENDYX15-HVJMY3NY					
MENDYX25-MNUN4V56	MENDYX15-HTYY62X5					
MENDYX25-MLBVM5LM	MENDYX15-HS8D8KKK					
MENDYX25-MKGLR68U	MENDYX15-HRN8QM4S					
MENDYX25-MHCDJ5XQ	MENDYX15-HKCEG84G					
MENDYX25-MGPK9SHE	MENDYX15-HHHMLV2V					
MENDYX25-MBCG4757	MENDYX15-HGUEWY4E					
MENDYX25-MAWGHLU9	MENDYX15-HEAS3SGS					
MENDYX25-M283WSMD	MENDYX15-H9DZV2YU					
MENDYX25-LRRECXL4	MENDYX15-H5C8VBGT					
MENDYX25-LPRXHZR3	MENDYX15-H3CZHDY6					
MENDYX25-LPQP45WQ	MENDYX15-GZ49PHUB					
MENDYX25-LPDCAKEV	MENDYX15-GWJUKPT9					
MENDYX25-LNUVDM8A	MENDYX15-GVGRLXWT					
MENDYX25-LLWUEHZY	MENDYX15-GTLP2BRK					
MENDYX25-LHT35A4N	MENDYX15-GTA8LSRK					
MENDYX25-LCTAQ7EG	MENDYX15-GQM92HU3					
MENDYX25-L7WHAU6C	MENDYX15-GJGCKKSC					
MENDYX25-L3SVQDXP	MENDYX15-GBK5FLR2					
MENDYX25-KZJVWYQD	MENDYX15-GB4YNEF3					
MENDYX25-KX77TC9U	MENDYX15-GA8KU9BP					
MENDYX25-KVWYSCZW	MENDYX15-G9QMAQ49					
MENDYX25-KVWRV2S6	MENDYX15-G7BST4XB					
MENDYX25-KP9ZRE3W	MENDYX15-G2Y76CTS					
MENDYX25-KNGYYYTY	MENDYX15-FZ98AJ44					
MENDYX25-KM86DMGC	MENDYX15-FYGDEGQ7					
MENDYX25-KKE789W4	MENDYX15-FW23CNA2					
MENDYX25-KHVCVH2U	MENDYX15-FV4B9YA8					
MENDYX25-KH4ZKPNZ	MENDYX15-FRRPUTT4					
MENDYX25-KFSWAYNL	MENDYX15-FR5U87GH					
MENDYX25-KD7B8T2S	MENDYX15-FNAQZD8D					
MENDYX25-KCU926XD	MENDYX15-FLY9K6DR					
MENDYX25-KC8CSPN2	MENDYX15-FKSS7593					
MENDYX25-K84TZVUM	MENDYX15-FJCP4N3M					
MENDYX25-K4E9SGXT	MENDYX15-FGWU56WZ					
MENDYX25-K3UBJS47	MENDYX15-FEZTR2Q4					
MENDYX25-K337USSU	MENDYX15-FDQCLJJ9					
MENDYX25-JZESRXFN	MENDYX15-FD7GRJXD					
MENDYX25-JYK55XPG	MENDYX15-F3WUZ4FP					
MENDYX25-JY9H9B6E	MENDYX15-F33JC9Q3					
MENDYX25-JXWU4YK6	MENDYX15-F2EU57CY					
MENDYX25-JUPZGJYU	MENDYX15-EZM7PW9E					
MENDYX25-JUC7KRBQ	MENDYX15-EZAZM6JR					
MENDYX25-JU37FA8B	MENDYX15-EYRTMAN7					
MENDYX25-JTFKUVBY	MENDYX15-ES5Y573M					
MENDYX25-JRT6RERS	MENDYX15-ERKXEVQ6					
MENDYX25-JPVV9QEK	MENDYX15-EQMS8YE7					
MENDYX25-JMF82Q8K	MENDYX15-EPXFQU8P					
MENDYX25-JKZZJTXT	MENDYX15-EPA39JCW					
MENDYX25-JK5CHVWQ	MENDYX15-EN5K4E7L					
MENDYX25-JCZ4FQTY	MENDYX15-ELN4DNX9					
MENDYX25-JB7YRNJG	MENDYX15-EHENTTKH					
MENDYX25-J9Y8MHJT	MENDYX15-EFA3P9NW					
MENDYX25-J892EX6S	MENDYX15-EEGX3XX4					
MENDYX25-J6SFZUNL	MENDYX15-EEC5X7RA					
MENDYX25-J674ER7W	MENDYX15-E94UBXPF					
MENDYX25-J4NZLSLW	MENDYX15-E79L4K2L					
MENDYX25-HY8M22BC	MENDYX15-E6PMCPJN					
MENDYX25-HWYCY98F	MENDYX15-E6FQWFWJ					
MENDYX25-HQV2AJB3	MENDYX15-E5M4MV6Y					
MENDYX25-HQ5KXRVX	MENDYX15-E3B7MSH2					
MENDYX25-HNET9WEF	MENDYX15-E36PY6H2					
MENDYX25-HL2MTXP6	MENDYX15-DXPJZ5RR					
MENDYX25-HGQJJTEZ	MENDYX15-DXJRS8VC					
MENDYX25-HF6ABXB3	MENDYX15-DXDSJDFG					
MENDYX25-HBXGUQ9L	MENDYX15-DUMQS4YU					
MENDYX25-HAMQ74BF	MENDYX15-DSZAFLA8					
MENDYX25-H8JHT275	MENDYX15-DQK75AMQ					
MENDYX25-H5Z95JA4	MENDYX15-DQ2SX6Y9					
MENDYX25-H3PXV42D	MENDYX15-DGH2YWLR					
MENDYX25-H2T4BZJY	MENDYX15-DEVFYRN9					
MENDYX25-GZCLALUE	MENDYX15-DDBTEENZ					
MENDYX25-GZ99DJPH	MENDYX15-CYTTQWKT					
MENDYX25-GXWHWHWV	MENDYX15-CU66BELE					
MENDYX25-GRXM2FJW	MENDYX15-CTNHFRRN					
MENDYX25-GRNU7X8V	MENDYX15-CSCJQ5S4					
MENDYX25-GP54FPBX	MENDYX15-CRNKQ874					
MENDYX25-GMXKZP3M	MENDYX15-CHTAKVBD					
MENDYX25-GJYVM3YB	MENDYX15-CAXJAYBK					
MENDYX25-GJGVNP8B	MENDYX15-C9WY49RU					
MENDYX25-GJ8MLDZ3	MENDYX15-C66N8QHH					
MENDYX25-GCM5ZDRT	MENDYX15-C56X9R5X					
MENDYX25-G8WD3N9X	MENDYX15-C2V5PXZ8					
MENDYX25-G8QW84GT	MENDYX15-C25RXAEX					
MENDYX25-G6GRQSBY	MENDYX15-BZJFT3L4					
MENDYX25-G5RKK9L7	MENDYX15-BYHCP8A4					
MENDYX25-G4PUMX9T	MENDYX15-BXMJLKTS					
MENDYX25-G4CUVV4C	MENDYX15-BULMZGY4					
MENDYX25-G42HQJ5L	MENDYX15-BNFQY4GG					
MENDYX25-G2DGJVDM	MENDYX15-BLJ24DUM					
MENDYX25-FSSVJMB9	MENDYX15-BGVKJQQU					
MENDYX25-FSRL3W5Y	MENDYX15-BAXL3TZU					
MENDYX25-FLG5HC48	MENDYX15-BADBQLNN					
MENDYX25-FL3HVY43	MENDYX15-B9DTEQTW					
MENDYX25-FFGHYQDS	MENDYX15-B85HK8SB					
MENDYX25-FDZJHVJU	MENDYX15-B7Y5VE64					
MENDYX25-F8X8NA6G	MENDYX15-B639LCYN					
MENDYX25-F8BESQCV	MENDYX15-B4NEZBBH					
MENDYX25-F7JAWUSZ	MENDYX15-B4J74M28					
MENDYX25-F58ABQQD	MENDYX15-B3H8K27W					
MENDYX25-F2HBVLNU	MENDYX15-AYPDRWSA					
MENDYX25-EZGGEB8G	MENDYX15-AY27J843					
MENDYX25-EX4SK9UH	MENDYX15-AWPLR2PG					
MENDYX25-ETCJHCGX	MENDYX15-ASVEY5VD					
MENDYX25-ERLFW8FP	MENDYX15-ADM8JR8S					
MENDYX25-EJTKXX85	MENDYX15-ABCDUGF4					
MENDYX25-EHWR2GTQ	MENDYX15-AAUE9MSZ					
MENDYX25-EGPWFKVF	MENDYX15-A8KQMJHM					
MENDYX25-EE5Q63XN	MENDYX15-A886WRFC					
MENDYX25-ED5DSP2U	MENDYX15-A59FBPQC					
MENDYX25-ECMQBALU	MENDYX15-A568L69G					
MENDYX25-EB9KXZCG	MENDYX15-9XVNGR5K					
MENDYX25-EAE68T8B	MENDYX15-9RPG647L					
MENDYX25-E9PSRD6Y	MENDYX15-9R4W6FXF					
MENDYX25-E6KZJEHX	MENDYX15-9PSWG5RU					
MENDYX25-E6CVZ2S6	MENDYX15-9MSYR4Q4					
MENDYX25-DVK8EEC8	MENDYX15-9KBWEYQ4					
MENDYX25-DQELVUTB	MENDYX15-9JGVLRQZ					
MENDYX25-DP88DBH4	MENDYX15-9H5CNGJM					
MENDYX25-DNKB2XQX	MENDYX15-9GZ6R9QM					
MENDYX25-DNG4UZA9	MENDYX15-9CH2ZP7Y					
MENDYX25-DLU3STUV	MENDYX15-9C2GVAQ8					
MENDYX25-DKAF9EK8	MENDYX15-97TR98HG					
MENDYX25-DEDXBH7V	MENDYX15-96RBK93S					
MENDYX25-DDAJFE73	MENDYX15-94ASJ6FD					
MENDYX25-D8RPD9YT	MENDYX15-93TGGB44					
MENDYX25-D8FZWWT6	MENDYX15-8XZSWGQ3					
MENDYX25-D7GLKMF3	MENDYX15-8VD6GYQ7					
MENDYX25-D6PFWQTG	MENDYX15-8U33SVZB					
MENDYX25-D3SNCJXE	MENDYX15-8TYA3Y6J					
MENDYX25-D2YGDVST	MENDYX15-8GTZJ2GU					
MENDYX25-CZKSDJ3J	MENDYX15-8DNCKE9P					
MENDYX25-CYTL69LT	MENDYX15-8D3DBME2					
MENDYX25-CV47V8KT	MENDYX15-8BYR6Y5J					
MENDYX25-CUUWED8L	MENDYX15-8AXP25MS					
MENDYX25-CUBSS8VV	MENDYX15-89EDBE5M					
MENDYX25-CTRKY652	MENDYX15-88GRPGSZ					
MENDYX25-CS75KYXT	MENDYX15-88CB96AG					
MENDYX25-CQWD4GGV	MENDYX15-856UPA5J					
MENDYX25-CQ7GQ4QE	MENDYX15-83K6DQPR					
MENDYX25-CP3YXVLE	MENDYX15-824AMRP4					
MENDYX25-CMJ7ECWR	MENDYX15-7ZH5P6QS					
MENDYX25-C7SCGA3K	MENDYX15-7YJEBYBR					
MENDYX25-C282MRDE	MENDYX15-7VJ3V974					
MENDYX25-BWNU73AV	MENDYX15-7V296PR8					
MENDYX25-BWKD68AF	MENDYX15-7UP2S8SL					
MENDYX25-BS6XJ65Z	MENDYX15-7REBFYMT					
MENDYX25-BJ6UW7UH	MENDYX15-7QADU4MR					
MENDYX25-BHWEDC4C	MENDYX15-7MGHRT98					
MENDYX25-BHE2A9J9	MENDYX15-7K28J3FZ					
MENDYX25-BFWD5JPS	MENDYX15-7GAT56UK					
MENDYX25-BENEJB7D	MENDYX15-7BU7LESX					
MENDYX25-BE3YU3M4	MENDYX15-7B6B55Z8					
MENDYX25-BD96FSVB	MENDYX15-79C576YS					
MENDYX25-BCQ3ZVAC	MENDYX15-76PCX4TF					
MENDYX25-BBPDBGM9	MENDYX15-6X6L4WNG					
MENDYX25-B9AAKPMK	MENDYX15-6PVKRH9V					
MENDYX25-B6YTKHDS	MENDYX15-6PSJRCFQ					
MENDYX25-B6JWKXE6	MENDYX15-6MCMNHR3					
MENDYX25-AXWTZMCR	MENDYX15-6MCJ4TKW					
MENDYX25-AVZC9R4X	MENDYX15-6LTSRYPS					
MENDYX25-AUGY886W	MENDYX15-6J5GL8ML					
MENDYX25-ANUXWMK5	MENDYX15-6H4L5F8W					
MENDYX25-AJTBUWC5	MENDYX15-6CVBN7ZG					
MENDYX25-AER23VJ2	MENDYX15-6CQ36XS5					
MENDYX25-ACDN8YV6	MENDYX15-6AE3JA2U					
MENDYX25-AACDVSXV	MENDYX15-69FG7KDC					
MENDYX25-A2V9BP7Q	MENDYX15-63LB92DV					
MENDYX25-9ZYV2BWG	MENDYX15-5YAPBUVY					
MENDYX25-9WYVUKTK	MENDYX15-5Y7JNZ6U					
MENDYX25-9RVV5352	MENDYX15-5X8YJMP9					
MENDYX25-9QJFSAFU	MENDYX15-5TKXB59G					
MENDYX25-9NZTZMP4	MENDYX15-5RUNSHWN					
MENDYX25-9K54BMAA	MENDYX15-5P357X6V					
MENDYX25-9K3ZWJBN	MENDYX15-5NY3ACU6					
MENDYX25-9J8BRQ5Q	MENDYX15-5HXJ7K96					
MENDYX25-9J3VE7JK	MENDYX15-5BUW433A					
MENDYX25-9DRLFPS5	MENDYX15-59VQPJBX					
MENDYX25-9DF5PR5F	MENDYX15-589TCY46					
MENDYX25-9CKQV4NX	MENDYX15-57DUR6D8					
MENDYX25-9AC55737	MENDYX15-537DTEWF					
MENDYX25-98RJ4BJ6	MENDYX15-4Z4CW5HK					
MENDYX25-978SF8JH	MENDYX15-4VQ5URBG					
MENDYX25-94QZUG8R	MENDYX15-4T2SQ8FE					
MENDYX25-93WMJ36P	MENDYX15-4RLQ27RF					
MENDYX25-93SHTG3H	MENDYX15-4Q6W8R7D					
MENDYX25-92C9TXLQ	MENDYX15-4MM63XDG					
MENDYX25-8ZRB5KQZ	MENDYX15-4LUH8G74					
MENDYX25-8YV9PFHJ	MENDYX15-4JBU7DU7					
MENDYX25-8WCQ4VLR	MENDYX15-4HUP77RY					
MENDYX25-8VCMS3HH	MENDYX15-4G8DSEAB					
MENDYX25-8UAG63GW	MENDYX15-4F5XQ7W7					
MENDYX25-8P483ZQR	MENDYX15-4EYYZSU6					
MENDYX25-8EFFVLNY	MENDYX15-4DXWRG4F					
MENDYX25-8E4B9UBQ	MENDYX15-4D8U3NT8					
MENDYX25-89S5P8AS	MENDYX15-4CV4ANG7					
MENDYX25-86CDNB5J	MENDYX15-4BNUWZBZ					
MENDYX25-7ZDLE7MS	MENDYX15-4BLU48PK					
MENDYX25-7WU7AEBX	MENDYX15-493TWY8P					
MENDYX25-7V9NEA22	MENDYX15-47H7J6K5					
MENDYX25-7UNMB64X	MENDYX15-43W4ALLM					
MENDYX25-7R6TKT46	MENDYX15-3VLNEZAQ					
MENDYX25-7QGRBEZM	MENDYX15-3U2CD9DG					
MENDYX25-7KTXAYQD	MENDYX15-3RGYF5NF					
MENDYX25-7K7C7D5B	MENDYX15-3R82DQR3					
MENDYX25-7J9M34XY	MENDYX15-3KR7VV4U					
MENDYX25-7EH5FMNZ	MENDYX15-3K9BMH86					
MENDYX25-7EC9PR6W	MENDYX15-3HDRWQYK					
MENDYX25-7E64PR3K	MENDYX15-3DSQB84H					
MENDYX25-7BWS2PTZ	MENDYX15-37VGAS2G					
MENDYX25-79XJBR3G	MENDYX15-2XZCVZYC					
MENDYX25-75N2H2AF	MENDYX15-2VAMLXRU					
MENDYX25-726E8HMZ	MENDYX15-2UR6R347					
MENDYX25-6Z4MZSZN	MENDYX15-2QCVGEF2					
MENDYX25-6X6UFDJX	MENDYX15-2PFGXXSG					
MENDYX25-6TUB8A3V	MENDYX15-2NYK6ZJK					
MENDYX25-6QVEP856	MENDYX15-2H8PC65E					
MENDYX25-6K7EZ4SL	MENDYX15-2EGTUM6R					
MENDYX25-6GUZVW9A	MENDYX15-2D7WKHFK					
MENDYX25-6GBM57GC	MENDYX15-2BHL5785					
MENDYX25-6B7KAX5D	MENDYX15-2B5W7XW8					
`;